// extracted by mini-css-extract-plugin
export default {"title":"g7JQm","mobile":"BMQth"};